import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, CardActions, Button } from '@material-ui/core';
import CudaPaper from 'common/components/CudaPaper'
import ContainersProblematicServicesPanel from './ContainersProblematicServicesPanel'
import { ReloadIcon } from 'common/components/icons';

const styles = {
    root: {
        width: '100%',
    },
    actions: {
        padding: '10px',
        marginTop: '-10px',
    },
    emptyTableCell: {
        textAlign: 'center',
        fontSize: '16px',
        color: '#777777',
        fontWeight: '300',
        height: '150px',
    },
};

const ContainersProblematicServices = ({
        classes,
        fetcher,
        items,
        reload,
    }) => {

    return  <CudaPaper loading={fetcher.loading}>
        <CardActions className={classes.actions} disableactionspacing="true">
            Containers Problematic Services
            <Button onClick={reload}>
                <ReloadIcon />
            </Button>
        </CardActions>
        <Grid container>
            {Object.keys(items).length > 0 ?
            Object.keys(items).map((s, sIndex) =>
            <Grid item xs={12} key={s}>
                <ContainersProblematicServicesPanel appId={s} data={items[s]}/>
            </Grid>)
            :
            <Grid container alignItems="center" className={classes.emptyTableCell}>                
                <Grid item xs={12}>
                    No Servers
                </Grid>
            </Grid>
            } 
        </Grid>
    </CudaPaper>

};

export default withStyles(styles)(ContainersProblematicServices);
